// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1263":"3129fa4c","2429":"3129fa4c","6534":"ce99d352"}[chunkId] + ".chunk.css";
};